<div class="card">
  <app-header
    titulo="Integrar Pagamentos"
    descricao="Pagamentos que ainda não foram integrados"
  ></app-header>

  <app-processamentocontrato></app-processamentocontrato>

</div>
